import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const complianceStateSelection = {
    name: "Compliance State",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose compliance state(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Compliance State",
    },
    type: "input",
    category: "dashboard",
};
